/* eslint-disable */
import React from "react";

// If style changes made to text-editor-pdf then update ReactTipTapEditor.css styles too
const TextEditorPDF = (props) => {
    if (props.companyNotes?.notes == '<p></p>' || props.companyNotes?.notes == '') {
        return null
    } else {
        const processedNotes = props.companyNotes?.notes.replace(/<p><\/p>/g, '<p>&nbsp;</p>');
        const pdfStyle = props.pdfStyle || 'text-editor-pdf'
        //  dangerouslySetInnerHTML will automatically break the div into different pages.
        return (
            <div className={pdfStyle} dangerouslySetInnerHTML={{ __html: processedNotes }}></div>
        )
    }
}

export default TextEditorPDF;